import React, {Component} from 'react';
import Styles from './style.css';
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {quotesRegister} from "../../services/quotesRegister";
import {cartRegister} from "../../services/cartRegister";
import {imagesRegister} from "../../services/imagesRegister";
import HeaderMobileMenu from "../header-mobile-menu/component";
import ModalLang from "../modal-lang/component";
import ModalLeave from "../modal-leave/component";
import {demoRegister} from "../../services/demoRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import queryString from "query-string";
import {agentRegister} from "../../services/agentRegister";

class HeaderSignUpOne extends Component {

    constructor(props) {
        super(props);
        this.state = {
            view: "",
            user: {},
            lang: null,
            temp_lang: null,
            language: false,
            dropdown: false,
            signup: false,
            leave: false,
            home: false,
            profile: false,
            languages: [],
            logout: false,
            private: false
        };
        this._lang = this._lang.bind(this);
        this._leave = this._leave.bind(this);
    };

    componentWillMount() {
        this._updateUser();
        this._updateView();
        this._updateLang();
        this._checkPrivate();
        this._updateLanguages();
    }

    _updateLang(){
        this.setState({lang: langRegister.lang()});
    }

    _updateUser() {
        let user = userRegister.get();
        if(user){
            this.setState({
                user: user
            });
        }
    }

    _updateView() {
        if (this.props.view) {
            this.setState({
                view: this.props.view
            });
        } else {
            this.setState({
                view: "register"
            });
        }
    }

    _updateLanguages() {
        let languages = JSON.parse(salesChannelRegister.get('languages'));
        if(Array.isArray(languages)){
            this.setState({languages: languages});
        }
    }

    _checkPrivate(){
        if(salesChannelRegister.get("private")){
            this.setState({private: salesChannelRegister.get("private")});
        }
    }

    _signout() {
        if(this.state.user){
            if(this.state.user.admin){
                this.setState({home: true, leave: true, logout: true});
            }else{

                try {
                    salesChannelRegister.set('socialIcon', salesChannelRegister.get('socialIcon-salesforce'));
                    salesChannelRegister.set('socialTitle', salesChannelRegister.get('socialTitle-salesforce'));
                    salesChannelRegister.set('facebookId', salesChannelRegister.get('facebookId-salesforce'));
                    salesChannelRegister.set('instagramId', salesChannelRegister.get('instagramId-salesforce'));
                }catch (e) {}

                demoRegister.remove();
                userRegister.remove();
                tokenRegister.remove();
                agentRegister.remove();
                window.location.reload();
            }
        }else{

            try {
                salesChannelRegister.set('socialIcon', salesChannelRegister.get('socialIcon-salesforce'));
                salesChannelRegister.set('socialTitle', salesChannelRegister.get('socialTitle-salesforce'));
                salesChannelRegister.set('facebookId', salesChannelRegister.get('facebookId-salesforce'));
                salesChannelRegister.set('instagramId', salesChannelRegister.get('instagramId-salesforce'));
            }catch (e) {}

            demoRegister.remove();
            userRegister.remove();
            tokenRegister.remove();
            agentRegister.remove();
            window.location.reload();
        }
    }

    _openMenu () {
        this.child._openMenu();
    }

    _register() {
        if(this.props.props.location.pathname.indexOf("signup") !== -1){
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/register" + "?from_path=" + this.props.props.location.pathname);
        }else{
            let query = queryString.parse(this.props.props.location.search);
            if(query){
                if(query.from_path){
                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/register?from_path=" + query.from_path);
                }else{
                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/register");
                }
            }else{
                this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/register");
            }
        }
    }

    _login() {
        if(this.props.props.location.pathname.indexOf("signup") !== -1){
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/login" + "?from_path=" + this.props.props.location.pathname);
        }else{
            let query = queryString.parse(this.props.props.location.search);
            if(query){
                if(query.from_path){
                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/login?from_path=" + query.from_path);
                }else{
                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/login");
                }
            }else{
                this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/login");
            }
        }
    }

    _profile(){
        try {
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/user/campaigns/running");
        } catch (e) {}
    }

    _lang(lang){
        if(lang){
            langRegister.set(lang);
            cartRegister.remove();
            quotesRegister.remove();
            imagesRegister.remove();
            if(this.props.props.location.pathname.indexOf("image") !== -1){
                this.props.props.history.replace("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/image");
                window.location.reload();
            }else{
                this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/image");
            }
        }else{
            this.setState({language: false});
        }
    }

    _setLang(prop){
        if(prop.toLowerCase() !== langRegister.lang().toLowerCase()){
            if(this.props.props.location.pathname.indexOf("signup") !== -1 && this.props.props.location.pathname.indexOf("signup/confirmation") === -1){
                this.setState({language: true, temp_lang: prop, dropdown: false}, () => {});
            }else{
                let string = "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name');
                let re = new RegExp(string,"g");
                let url = this.props.props.location.pathname.replace(re,'');
                langRegister.set(prop);
                this.props.props.history.replace("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + url);
                window.location.reload();
            }
        }
        else{
            this.setState({dropdown: false});
        }
    }

    _leave(value){
        if(value){
            if(this.state.home){
                try {
                    if(this.state.user.admin){
                        if(this.state.logout){

                            try {
                                salesChannelRegister.set('socialIcon', salesChannelRegister.get('socialIcon-salesforce'));
                                salesChannelRegister.set('socialTitle', salesChannelRegister.get('socialTitle-salesforce'));
                                salesChannelRegister.set('facebookId', salesChannelRegister.get('facebookId-salesforce'));
                                salesChannelRegister.set('instagramId', salesChannelRegister.get('instagramId-salesforce'));
                            }catch (e) {}

                            tokenRegister.remove();
                            userRegister.remove();
                            agentRegister.remove();
                            demoRegister.remove();
                        }
                        imagesRegister.remove();
                        cartRegister.remove();
                        quotesRegister.remove();
                    }
                }catch (error){}
                try {
                    if(this.props.props.location.pathname.indexOf("image") !== -1){
                        imagesRegister.remove();
                        cartRegister.remove();
                        quotesRegister.remove();
                        window.location.reload();
                    }else{
                        imagesRegister.remove();
                        cartRegister.remove();
                        quotesRegister.remove();
                        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/image");
                    }
                } catch (e) {}
            }else if(this.state.profile){
                this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/user/campaigns/running");
            }else{
                if(this.props.props.location.pathname.indexOf("image") !== -1){
                    imagesRegister.remove();
                    cartRegister.remove();
                    quotesRegister.remove();
                    window.location.reload();
                }else{
                    imagesRegister.remove();
                    cartRegister.remove();
                    quotesRegister.remove();
                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/image");
                }
            }
        }else{
            this.setState({leave: false});
        }
    }

    _renderText(item) {
        return langRegister.get("signup-header-one", item);
    }

    render() {
        return (
            <div>
                {
                    this.state.language &&
                    <ModalLang setLang={this._lang} lang={this.state.temp_lang} props={this.props}/>
                }
                {
                    this.state.leave &&
                    <ModalLeave setLeave={this._leave} props={this.props}/>
                }
                <div className={Styles.header}>
                    {
                        this.state.dropdown &&
                        <div onClick={() => this.setState({dropdown: false})} className={Styles.languageButtonContainerOverlay}/>
                    }
                    <div className={Styles.logoContainer}>
                        <img onClick={() => {
                            if(this.props.props.location.pathname.indexOf("signup") !== -1 && this.props.props.location.pathname.indexOf("signup/confirmation") === -1){
                                this.setState({leave: true, home: true})
                            }else{
                                if(this.props.props.location.pathname.indexOf("image") !== -1){
                                    window.location.reload();
                                }else{
                                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/image");
                                }
                            }}
                        } className={Styles.logoContainerIcon} src={salesChannelRegister.get('logo')}/>
                        <img onClick={() => {
                            if(this.props.props.location.pathname.indexOf("signup") !== -1 && this.props.props.location.pathname.indexOf("signup/confirmation") === -1){
                                this.setState({leave: true, home: true})
                            }else{
                                if(this.props.props.location.pathname.indexOf("image") !== -1){
                                    window.location.reload();
                                }else{
                                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/image");
                                }
                            }}
                        } className={Styles.logoContainerIconMobile}
                             src={salesChannelRegister.get('logo_mobile')}/>
                    </div>
                    <div className={Styles.menuContainer}></div>
                    {
                        this.state.view !== "select-market" &&
                        <div className={Styles.buttonContainer}>
                            <div className={Styles.languageButtonContainer}>
                                <div onClick={() => this.setState({dropdown: !this.state.dropdown})} className={Styles.languageButton}>
                                    {this.state.lang}
                                </div>
                                {
                                    this.state.dropdown &&
                                    <div>
                                        <div className={Styles.languageButtonDropdown}>
                                            {
                                                this.state.languages.map((item) => {
                                                    return(
                                                        <div onClick={() => this._setLang(item.code)} className={Styles.languageButtonDropdownItem}>
                                                            {item.names[langRegister.lang()]}
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div className={Styles.languageButtonTriangle}/>
                                    </div>
                                }
                            </div>
                            {
                                salesChannelRegister.get("name") !== "yieldlock" &&
                                tokenRegister.get() && !this.state.user.inhouse && !this.state.user.reseller &&
                                <img onClick={() => {
                                    if(this.props.props.location.pathname.indexOf("signup/confirmation") === -1 && this.props.props.location.pathname.indexOf("signup") !== -1){
                                        this.setState({leave: true, profile: true})
                                    }else{
                                        this._profile();
                                    }}
                                } className={Styles.buttonContainerUserIcon} src={require("../../assets/images/user_icon.svg")}/>
                            }
                            {
                                salesChannelRegister.get("name") === "yieldlock" &&
                                tokenRegister.get() && !this.state.user.inhouse && !this.state.user.reseller &&
                                <img onClick={() => {
                                    if(this.props.props.location.pathname.indexOf("signup/confirmation") === -1 && this.props.props.location.pathname.indexOf("signup") !== -1){
                                        this.setState({leave: true, profile: true})
                                    }else{
                                        this._profile();
                                    }}
                                } className={Styles.buttonContainerUserIcon} src={require("../../assets/images/user_icon_yl.svg")}/>
                            }
                            {
                                salesChannelRegister.get("name") !== "yieldlock" &&
                                tokenRegister.get() && (this.state.user.reseller || this.state.user.inhouse) &&
                                <img onClick={() => {
                                    if(this.props.props.location.pathname.indexOf("signup/confirmation") === -1 && this.props.props.location.pathname.indexOf("signup") !== -1){
                                        this.setState({leave: true, profile: true})
                                    }else{
                                        this._profile();
                                    }}
                                } className={Styles.buttonContainerUserIcon} src={require("../../assets/images/user_icon_reseller.svg")}/>
                            }
                            {
                                salesChannelRegister.get("name") === "yieldlock" &&
                                tokenRegister.get() && (this.state.user.reseller || this.state.user.inhouse) &&
                                <img onClick={() => {
                                    if(this.props.props.location.pathname.indexOf("signup/confirmation") === -1 && this.props.props.location.pathname.indexOf("signup") !== -1){
                                        this.setState({leave: true, profile: true})
                                    }else{
                                        this._profile();
                                    }}
                                } className={Styles.buttonContainerUserIcon} src={require("../../assets/images/user_icon_reseller_yl.svg")}/>
                            }
                            {
                                !tokenRegister.get() && this.state.view === "login" && !this.state.private &&
                                <div onClick={() => this._register()} className={Styles.buttonContainerSignIn}>
                                    {this._renderText("item_1")}
                                </div>
                            }
                            {
                                !tokenRegister.get() && this.state.view === "login" && this.state.private &&
                                <div onClick={() => this._login()} className={Styles.buttonContainerSignIn}>
                                    {this._renderText("item_3")}
                                </div>
                            }
                            {
                                !tokenRegister.get() && this.state.view !== "login" &&
                                <div onClick={() => this._login()} className={Styles.buttonContainerSignIn}>
                                    {this._renderText("item_3")}
                                </div>
                            }
                            {
                                tokenRegister.get() &&
                                <div onClick={() => this._signout()} className={Styles.buttonContainerSignIn}>
                                    {this._renderText("item_2")}
                                </div>
                            }
                            <img onClick={() => this._openMenu()} className={Styles.buttonContainerMobileMenu}
                                 src={require("../../assets/images/menu_icon.svg")}/>
                        </div>

                    }
                    <HeaderMobileMenu props={this.props.props} ref={instance => {this.child = instance}} layout={true}/>
                </div>
            </div>
        );
    }
}

export default HeaderSignUpOne;


// WEBPACK FOOTER //
// ./src/components/header-signup-one/component.js